
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

     filteredVariants(arr, excludedOption, currentVariant) {
        return arr.filter(v => {
          // 新增：过滤掉价格为 0 的样品变体，防止被主题自动选中
          if (v.price === 0) return false;

          return ['option1', 'option2', 'option3'].every(key => {
            if (key === excludedOption) return true;
            return v[key] === currentVariant[key];
          });
        });
      }
      async removeCartItems(variants) {
        if (!variants || variants.length === 0) return;
        const formData = new FormData();
        variants.forEach(({ id }) => {
           formData.append(`updates[${id}]`, 0);
        })
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }

      valideVariantId(productId, variantId, currentQuantity) {
        if (!productId) return;
        const currentItem = document.querySelector(`.cart-item[data-product-id="${productId}"]`);
        
        let variants, optionQuantityPosition;
        if (currentItem) {
          optionQuantityPosition = currentItem.dataset.position;
          const textJson = currentItem.querySelector('script[type="application/json"]').textContent;
          variants = JSON.parse(textJson);
        } else {
          const variantPicker = this.closest('product-info')?.querySelector('variant-selects');
          if (!variantPicker) return;
          const textJson = variantPicker.querySelector('script[type="application/json"]')?.textContent;
          if (!textJson) return;
          variants = JSON.parse(textJson);
          
          const quantityOption = variantPicker.querySelector('.input-option-quantity');
          optionQuantityPosition = quantityOption?.dataset.optionQuantityPosition;
        }

        if(!variants || !optionQuantityPosition) return;

        const excludedOption = `option${optionQuantityPosition}`;
        const currentVariant = variants.find(variant => variant.id == variantId);
        if (!currentVariant) return;

        const variantsfiltered = this.filteredVariants(variants, excludedOption, currentVariant); 
        
        const productIdAdded = this.cartItems.map(item => {
          const id = item.dataset.productId;
          const variantId = item.dataset.variantId;
          if(id == productId) return variantId
        });

        const VariantsAdded = productIdAdded.map( id => {
           return variants.find(variant => variant.id == id)
        }).filter(Boolean);
       
        const commonOptionsFilter = this.filteredVariants(VariantsAdded, excludedOption, currentVariant);
        
        const quantityVariants = commonOptionsFilter.map( variant => {
          const id = variant.id;
          const item = document.querySelector(`.cart-item[data-variant-id="${id}"]`);
          return item ? +item.dataset.quantity : 0;
        });

        
        const total_quantity = quantityVariants.reduce((acc, quantity) => {
            return acc + quantity;
        }, currentQuantity);

        let optionQuantityValue = '';
        if(excludedOption == 'option') return
        variantsfiltered.forEach( variant => {
          const arr = variant[excludedOption].split('-');
          if(arr.length == 2) {
            const start = +arr[0];
            const end = +arr[1];
            if(total_quantity >= start && total_quantity <= end) {
              optionQuantityValue = variant[excludedOption];
            }
          }else {
            const start = +arr[0].replace(/[\D]+/g, '');
            if(total_quantity >= start ) {
              optionQuantityValue = variant[excludedOption];
            }
          }
        });

        const valideVariant = variantsfiltered.find( variant => variant[excludedOption] == optionQuantityValue);
        if (!valideVariant) return;

        // 如果计算出的正确变体就是当前要添加的变体，且购物车中没有需要清理的旧变体，则不需要特殊处理
        if (valideVariant.id == variantId && commonOptionsFilter.length === 0) return;

        return { variantsRemove:commonOptionsFilter, variantId: valideVariant.id, quantity:total_quantity };
      }
      checkedCartItems(formData) {
        this.cartItems = Array.from(document.querySelectorAll('cart-drawer-items .cart-item, cart-items .cart-item'));

        const productId = formData.get('product-id');
        const productQuantity = +formData.get('quantity');
        const currentVariantId = formData.get('id');

        if (!productId || isNaN(productQuantity) || productQuantity <= 0) return;

        return this.valideVariantId(productId, currentVariantId, productQuantity);
      }
      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        
       const valideVariant = this.checkedCartItems(formData);
        if(valideVariant) {
          formData.set("id", valideVariant.variantId);
          formData.set("quantity", valideVariant.quantity);
          await this.removeCartItems(valideVariant.variantsRemove);
        }


        config.body = formData;
        await fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton?.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
